import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49d11ce1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search" }
const _hoisted_2 = { class: "search_toggle_box" }
const _hoisted_3 = { class: "search_input_wrap" }
const _hoisted_4 = ["onKeyup", "onKeydown"]
const _hoisted_5 = {
  key: 0,
  class: "recent_search"
}
const _hoisted_6 = ["onMouseover", "onMouseleave", "onMousedown"]
const _hoisted_7 = ["onMousedown"]

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import IconButton from '@/components/molecules/IconButton'
import ConditionDialog from './ConditionDialog'
import { splitStringOnSpace, checkPlatform } from '@/js/utils/util'
import { formatQueryToArray } from '@/js/utils/filters'
import Icon from '@/components/atoms/Icon.vue'
import type {
  ConditionDialogTag,
  SearchDetailQuery,
  SearchListQuery,
  SearchRouteQuery,
} from '../types'


const __default__ = {
  name: 'search',
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore()
const route = useRoute()
const router = useRouter()

const isSearchFieldOpen = ref(true)
const toggleDisplayState = ref(false)
const keyword = ref('')
const selectedTags = ref<string[]>([])
const selectedFunc = ref<string[]>([])
const selectedWatchStatus = ref<string | undefined>('')
const detailQuery = ref<SearchDetailQuery | null>(null)
const recentSearchKeyword = ref<string[]>([])
const searchState = ref(false)
const focusedListIndex = ref(-1)
const searchInput = ref<HTMLInputElement | null>(null)

const tags = computed<ConditionDialogTag[]>(() => store.getters['tag/tags'])

const buildRouteQuery = (queryData: SearchDetailQuery): SearchRouteQuery => {
  const query: SearchRouteQuery = {
    filter: formatQueryToArray(queryData.filter) || [],
    tags: formatQueryToArray(queryData.tags) || [],
    func: formatQueryToArray(queryData.func) || [],
  }
  if (queryData.watch_status) {
    query.watch_status = queryData.watch_status
  }
  return query
}

const routeQuery = computed<SearchRouteQuery>(() => {
  const queryData = detailQuery.value ? detailQuery.value : route.query
  return buildRouteQuery(queryData as SearchDetailQuery)
})

const isSetFilter = computed(() => {
  const query = detailQuery.value ? detailQuery.value : routeQuery.value

  return Object.keys(query)
    .map((key) => query[key as keyof typeof query])
    .some((d) => {
      if (Array.isArray(d)) {
        return d.length > 0
      }
      if (typeof d === 'string') {
        return d.length > 0
      }
      return false
    })
})

const filterIconColor = computed(() => {
  return isSetFilter.value ? 'color-secondary' : null
})

const recentSearchKeywords = computed(() => {
  let keywords = recentSearchKeyword.value
  if (keyword.value.length > 0) {
    keywords = keywords.filter((s) => s.toLowerCase().includes(keyword.value))
  }
  return keywords.slice(0, 5)
})

const searchFieldToggle = () => {
  isSearchFieldOpen.value = !isSearchFieldOpen.value
}

const toggleConditionDialog = () => {
  resetConditions()
  toggleDisplayState.value = !toggleDisplayState.value
}

const search = () => {
  const query: SearchListQuery = {
    filter: [],
    tags: [],
    func: [],
    watch_status: '',
  }

  if (focusedListIndex.value > -1) {
    keyword.value = recentSearchKeywords.value[focusedListIndex.value]
  }

  if (keyword.value !== '' && keyword.value !== null) {
    query.filter = splitStringOnSpace(keyword.value)
    saveRecentSearchKeyword(keyword.value)
  }

  query.tags = selectedTags.value
  query.func = selectedFunc.value
  query.watch_status = selectedWatchStatus.value

  if (query.watch_status === '') {
    delete query.watch_status
  }

  if (route.query.view) {
    query.view = route.query.view
  }
  if (route.query.division) {
    query.division = route.query.division
  }

  unSetRecentSearch()
  searchInput.value?.blur()

  router
    .push({
      name: 'list',
      params: { page: 1 },
      query: query,
    })
    .catch(() => {})
}

const loadRecentSearchKeyword = () => {
  recentSearchKeyword.value = store.getters['search/recentSearch']
}

const saveRecentSearchKeyword = (searchKeyword: string) => {
  let keywords: string[] = store.getters['search/recentSearch']

  keywords = keywords.filter((item) => item !== searchKeyword)
  keywords.unshift(searchKeyword)

  store.commit('search/setRecentSearch', keywords)
  recentSearchKeyword.value = keywords
}

const deleteRecentSearchKeyword = (searchKeyword: string) => {
  let keywords: string[] = store.getters['search/recentSearch']

  keywords = keywords.filter((item) => item !== searchKeyword)

  store.commit('search/setRecentSearch', keywords)
  recentSearchKeyword.value = keywords
}

const setRecentSearch = () => {
  searchState.value = true
  focusedListIndex.value = -1
}

const unSetRecentSearch = () => {
  searchState.value = false
  focusedListIndex.value = -1
}

const showSearchState = () => {
  searchState.value = true
}

const hideRecentSearch = () => {
  searchState.value = false
}

const setFocusKeyword = (index: number) => {
  focusedListIndex.value = index
}

const unSetFocusKeyword = () => {
  focusedListIndex.value = -1
}

const resetConditions = () => {
  keyword.value = routeQuery.value.filter.join(' ') || ''
  selectedTags.value = routeQuery.value.tags || []
  selectedFunc.value = routeQuery.value.func || []
  selectedWatchStatus.value = routeQuery.value.watch_status
}

const listUp = () => {
  if (searchState.value === false) {
    showSearchState()
  }
  if (focusedListIndex.value > 0) {
    focusedListIndex.value--
  } else {
    focusedListIndex.value = recentSearchKeywords.value.length - 1
  }
}

const listDown = () => {
  if (searchState.value === false) {
    showSearchState()
  }
  if (focusedListIndex.value < recentSearchKeywords.value.length - 1) {
    focusedListIndex.value++
  } else {
    focusedListIndex.value = 0
  }
}

onMounted(() => {
  keyword.value = routeQuery.value.filter.join(' ')
  resetConditions()
  loadRecentSearchKeyword()

  if (checkPlatform() === 'sm') {
    isSearchFieldOpen.value = false
  }
})

watch(
  () => route,
  (to, from) => {
    if (to.name === 'detail' && from?.name === 'list') {
      detailQuery.value = from.query as SearchDetailQuery
    } else if (to.name !== 'detail') {
      detailQuery.value = null
    }
  }
)

watch(routeQuery, () => {
  resetConditions()
})

watch(keyword, () => {
  focusedListIndex.value = -1
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["search_btn", { isSetFilter: _unref(isSetFilter) }])
    }, [
      _createVNode(_unref(IconButton), {
        onClick: searchFieldToggle,
        useBorder: false,
        icon: "search"
      })
    ], 2),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
              type: "search",
              class: "search_input",
              ref_key: "searchInput",
              ref: searchInput,
              onKeyup: [
                _withKeys(search, ["enter"]),
                _withKeys(_withModifiers(listUp, ["prevent"]), ["up"])
              ],
              onKeydown: [
                _withKeys(hideRecentSearch, ["esc"]),
                _withKeys(_withModifiers(listDown, ["prevent"]), ["down"])
              ],
              onFocus: setRecentSearch,
              onBlur: unSetRecentSearch,
              "data-test": "search-input-keyword",
              onClick: showSearchState
            }, null, 40, _hoisted_4), [
              [_vModelText, keyword.value]
            ]),
            _createVNode(_unref(IconButton), {
              useBorder: false,
              icon: "filter_list",
              "icon-color": _unref(filterIconColor),
              onClick: toggleConditionDialog,
              "data-test": "search-icon-button-filter-list"
            }, null, 8, ["icon-color"])
          ]),
          (searchState.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recentSearchKeywords), (recentKeyword, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: recentKeyword + index,
                      class: _normalizeClass(["recent_search_li", [
                {
                  focus_recent_search_li: index === focusedListIndex.value,
                },
              ]]),
                      tabindex: "0",
                      onMouseover: _withModifiers(($event: any) => (setFocusKeyword(index)), ["prevent"]),
                      onMouseleave: _withModifiers(unSetFocusKeyword, ["prevent"]),
                      onMousedown: _withModifiers(search, ["prevent"])
                    }, [
                      _createElementVNode("span", null, [
                        _createVNode(Icon, {
                          size: "12",
                          color: "color-dark2",
                          type: "history"
                        }),
                        _createTextVNode(" " + _toDisplayString(recentKeyword), 1)
                      ]),
                      _createElementVNode("span", {
                        class: "search_delete_button",
                        onMousedown: _withModifiers(($event: any) => (deleteRecentSearchKeyword(_unref(recentSearchKeywords)[index])), ["stop","prevent"])
                      }, [
                        _createVNode(_unref(IconButton), {
                          useBorder: false,
                          icon: "delete"
                        })
                      ], 40, _hoisted_7)
                    ], 42, _hoisted_6))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_unref(IconButton), {
            class: "trigger_btn",
            useBorder: false,
            bgColor: "primary",
            icon: "keyboard_arrow_right",
            "icon-color": "color-white",
            onClick: search,
            "data-test": "search-icon-button-trigger"
          })
        ], 512), [
          [_vShow, isSearchFieldOpen.value]
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(ConditionDialog), {
      toggleDisplayState: toggleDisplayState.value,
      "onUpdate:toggleDisplayState": _cache[1] || (_cache[1] = ($event: any) => ((toggleDisplayState).value = $event)),
      selectedTags: selectedTags.value,
      "onUpdate:selectedTags": _cache[2] || (_cache[2] = ($event: any) => ((selectedTags).value = $event)),
      selectedFunc: selectedFunc.value,
      "onUpdate:selectedFunc": _cache[3] || (_cache[3] = ($event: any) => ((selectedFunc).value = $event)),
      selectedWatchStatus: selectedWatchStatus.value,
      "onUpdate:selectedWatchStatus": _cache[4] || (_cache[4] = ($event: any) => ((selectedWatchStatus).value = $event)),
      tags: _unref(tags),
      onSearch: search
    }, null, 8, ["toggleDisplayState", "selectedTags", "selectedFunc", "selectedWatchStatus", "tags"])
  ]))
}
}

})